// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/fontawesome/css/all.css
// module id = 558
// module chunks = 1